import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components/macro';
import { DeviceSize } from '../basic/DeviceSize';

const baseFontStyle = css`
  font-family: ${(props) => props.theme.text.primaryFont};
  color: ${(props) => props.theme.text.fontColor};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  font-feature-settings: 'ss01';
`;

export const H2Style = css`
  font-size: 36px;
  line-height: 125%;
  font-family: ${(props) => props.theme.text.secondaryFont};
  font-weight: 700;

  @media ${DeviceSize.mobileL} {
    font-size: 24px;
  }
`;

export const H5Style = css`
  ${baseFontStyle};
  font-family: ${(props) => props.theme.text.secondaryFont};
  font-size: 18px;
  font-weight: 700;
`;

export const H6Style = css`
  ${baseFontStyle};
  font-family: ${(props) => props.theme.text.secondaryFont};
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0;
`;

export const Label1 = styled.p`
  ${baseFontStyle};
  font-size: 18px;
  font-weight: 600;
  line-height: 120%;
  margin: 0;
`;

export const Label2 = styled.p`
  ${baseFontStyle};
  font-size: 16px;
  font-weight: 700;
  line-height: 120%;
  margin: 0;
`;

export const Body1 = styled.p<{ margin?: React.CSSProperties['margin']; $color?: React.CSSProperties['color'] }>`
  ${baseFontStyle};
  font-size: 18px;
  line-height: 150%;
  margin: ${({ margin }) => margin || 'initial'};

  ${({ $color }) => $color && `color: ${$color};`}

  @media ${DeviceSize.mobileL} {
    font-size: 16px;
  }
`;

export const Body2 = styled.p<{ margin?: React.CSSProperties['margin']; $color?: React.CSSProperties['color'] }>`
  ${baseFontStyle};
  font-size: 16px;
  line-height: 150%;
  ${({ margin }) => margin && `margin: ${margin};`}

  ${({ $color }) => $color && `color: ${$color};`}

  @media ${DeviceSize.mobileL} {
    font-size: 14px;
  }
`;

export const Body3 = styled.p`
  ${baseFontStyle};
  font-size: 14px;
  line-height: 150%;
  margin: 0;

  @media ${DeviceSize.mobileL} {
    font-size: 12px;
  }
`;

export const Body4 = styled.p`
  ${baseFontStyle};
  font-size: 12px;
  line-height: 150%;
  margin: 0;

  @media ${DeviceSize.mobileL} {
    font-size: 10px;
  }
`;

export const BasicText = styled.span`
  font-family: ${(props) => props.theme.text.primaryFont};
  color: ${(props) => props.theme.text.fontColor};
  font-size: 16px;
  line-height: 150%;
`;

export const H1 = styled.h1`
  ${H2Style}
`;

export const H4 = styled.h4`
  ${baseFontStyle};
  font-family: ${(props) => props.theme.text.secondaryFont};
  font-weight: 600;
  font-size: 21px;
  line-height: 150%;
  margin: 0;

  @media ${DeviceSize.mobileL} {
    font-size: 18px;
  }
`;

export const H6 = styled.h6`
  ${H6Style};
`;

const textButtonStyles = css`
  background: none;
  cursor: pointer;
  text-decoration: underline;
  border: none;
  font-size: 16px;
  font-family: ${(props) => props.theme.text.primaryFont};
`;

export const TextButton = styled.button`
  ${textButtonStyles}
`;

export const TextLink = styled(Link)`
  ${textButtonStyles}
  color: ${(props) => props.theme.text.fontColor};
`;

export const TextLinkExternal = styled.a`
  ${textButtonStyles}
  color: ${(props) => props.theme.text.fontColor};
`;
